export * from './side-menu.model'


// WEBPACK FOOTER //
// ./src/app/application/model/index.ts